import { render, staticRenderFns } from "./OrderSendMessage.vue?vue&type=template&id=03195896&scoped=true"
import script from "./OrderSendMessage.vue?vue&type=script&lang=js"
export * from "./OrderSendMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03195896",
  null
  
)

export default component.exports